module.exports = __webpack_public_path__ + "static/media/Morelull_gaussian2.76b6037e.png";